module.exports = __webpack_public_path__ + "img/700m.ed4745ac.png";